import { FormClass } from '@/common/class/form.class'
import { ToolsClass } from '@/common/class/tools.class'

export default {
  methods: {
    isFormValid () {
      return !!this.form?.valid
    },
    scrollToError () {
      setTimeout(() => {
        const errorElement = document.querySelector('.is-error')
        if (errorElement) {
          ToolsClass.scrollToElementTop(errorElement, -20)
          const alert = errorElement.querySelector('[role="alert"]')
          if (alert) {
            alert.focus()
          }
        }
      }, 500)
    },
    isFormSubmitted () {
      return FormClass.isFormSubmitted(this.form)
    },
    isErrorForField (fieldName) {
      return FormClass.showErrorForField(fieldName, this.form)
    },
    addErrorToField (fieldName, validatorName, error = true) {
      return FormClass.addErrorToField(error, validatorName, fieldName, this.form)
    },
    getFieldErrorText (fieldName) {
      const errors = {
        required: this.$t('validation.required'),
        email: this.$t('validation.emailInvalid'),
        phone: this.$t('validation.phoneInvalid'),
        password: this.$t('validation.passwordTooWeak'),
        passwordConfirm: this.$t('validation.passwordsNotMatch'),
        blikInvalid: this.$t('validation.blikCodeInvalid')
      }
      const error = FormClass.getErrorForField(fieldName, this.form)
      return errors[error] || error
    }
  }
}
